import React from 'react';
import { Link } from 'react-router-dom';

function getDashboardVariant(title) {
  const t = String(title || '').toLowerCase();
  if (t.includes('resolved')) return 'resolved';
  if (t.includes('progress') || t.includes('review')) return 'inprogress';
  if (t.includes('overdue')) return 'overdue';
  return 'total';
}

function getLeaveVariant(title) {
  const t = String(title || '').toLowerCase();
  if (t.includes('available')) return 'leaveAvailable';
  if (t.includes('accepted')) return 'leaveAccepted';
  if (t.includes('rejected')) return 'leaveRejected';
  if (t.includes('lop')) return 'leaveLop';
  if (t === 'applied') return 'leaveApplied';
  return 'leaveTotal';
}

const VARIANT_STYLES = {
  total: {
    border: 'border-brand',
    value: 'text-brand',
    iconBg: 'bg-brand/10',
    iconColor: 'text-brand',
  },
  resolved: {
    border: 'border-emerald-500',
    value: 'text-emerald-600',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
  },
  inprogress: {
    border: 'border-amber-500',
    value: 'text-amber-600',
    iconBg: 'bg-amber-50',
    iconColor: 'text-amber-600',
  },
  overdue: {
    border: 'border-red-500',
    value: 'text-red-600',
    iconBg: 'bg-red-50',
    iconColor: 'text-red-600',
  },
  leaveTotal: {
    border: 'border-brand',
    value: 'text-brand',
    iconBg: 'bg-brand/10',
    iconColor: 'text-brand',
  },
  leaveApplied: {
    border: 'border-sky-500',
    value: 'text-sky-600',
    iconBg: 'bg-sky-50',
    iconColor: 'text-sky-600',
  },
  leaveAccepted: {
    border: 'border-emerald-500',
    value: 'text-emerald-600',
    iconBg: 'bg-emerald-50',
    iconColor: 'text-emerald-600',
  },
  leaveRejected: {
    border: 'border-gray-500',
    value: 'text-gray-600',
    iconBg: 'bg-gray-100',
    iconColor: 'text-gray-600',
  },
  leaveLop: {
    border: 'border-violet-500',
    value: 'text-violet-600',
    iconBg: 'bg-violet-50',
    iconColor: 'text-violet-600',
  },
  leaveAvailable: {
    border: 'border-teal-500',
    value: 'text-teal-600',
    iconBg: 'bg-teal-50',
    iconColor: 'text-teal-600',
  },
};

function MetricIcon({ variant, className = '' }) {
  const props = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    className,
    'aria-hidden': true,
  };

  // Dashboard icons
  if (variant === 'resolved') {
    return (
      <svg {...props}>
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    );
  }
  if (variant === 'inprogress') {
    return (
      <svg {...props}>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    );
  }
  if (variant === 'overdue') {
    return (
      <svg {...props}>
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    );
  }
  if (variant === 'total') {
    return (
      <svg {...props}>
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    );
  }

  // Leave-specific icons (calendar / leave themed)
  if (variant === 'leaveApplied') {
    return (
      <svg {...props}>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="12" y1="18" x2="12" y2="12" />
        <line x1="9" y1="15" x2="15" y2="15" />
      </svg>
    );
  }
  if (variant === 'leaveAccepted') {
    return (
      <svg {...props}>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <path d="M9 16l2 2 4-4" />
      </svg>
    );
  }
  if (variant === 'leaveRejected') {
    return (
      <svg {...props}>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <line x1="10" y1="14" x2="14" y2="18" />
        <line x1="14" y1="14" x2="10" y2="18" />
      </svg>
    );
  }
  if (variant === 'leaveLop') {
    return (
      <svg {...props}>
        <rect x="2" y="6" width="20" height="12" rx="2" />
        <circle cx="12" cy="12" r="2" />
        <path d="M6 12h.01M18 12h.01" />
      </svg>
    );
  }
  if (variant === 'leaveAvailable') {
    return (
      <svg {...props}>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    );
  }

  // leaveTotal — calendar
  return (
    <svg {...props}>
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function MetricCard({ title, value, to, colorScheme = 'default', iconSet = 'dashboard' }) {
  const variantKey =
    iconSet === 'leave' ? getLeaveVariant(title) : getDashboardVariant(title);
  const variant = VARIANT_STYLES[variantKey] || VARIANT_STYLES.total;
  const isBackend = colorScheme === 'backend';

  const valueClass = isBackend ? 'text-red-700' : variant.value;
  const borderClass = isBackend ? 'border-red-600' : variant.border;
  const iconBg = isBackend ? 'bg-red-50' : variant.iconBg;
  const iconColor = isBackend ? 'text-red-700' : variant.iconColor;

  const cardClass = `group flex h-full min-h-[5.5rem] flex-col rounded-xl border-l-4 bg-white p-3 shadow-sm transition hover:shadow-md sm:min-h-[6.25rem] sm:p-4 ${borderClass}`;

  const content = (
    <>
      <div className="mb-2 flex items-start justify-between gap-2">
        <span
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg sm:h-9 sm:w-9 ${iconBg} ${iconColor}`}
        >
          <MetricIcon variant={variantKey} />
        </span>
        <p className={`text-2xl font-bold leading-none tabular-nums sm:text-3xl ${valueClass}`}>
          {value}
        </p>
      </div>
      <p className="mt-auto text-[11px] font-semibold leading-snug text-gray-600 sm:text-xs">
        {title}
      </p>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={`${cardClass} focus:outline-none focus:ring-2 focus:ring-brand`}>
        {content}
      </Link>
    );
  }

  return <div className={cardClass}>{content}</div>;
}

export default MetricCard;
